<template>
    <b-modal id="modal-prevent-closing" ref="modal" @show="resetModal" @hidden="resetModal" @ok="handleOk"
        :title="$gettext('Generate New Report')">
        <b-form-group label-cols="4" label-cols-lg="2" :label="$gettext('Year')" label-for="year-select">
            <b-form-select v-model="yearModal" :options="financialYears" id="year-select"></b-form-select>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" :label="$gettext('Period')" label-for="period-select">
            <b-form-select v-model="report_type" :options="REPORT_TYPES" id="period-select"></b-form-select>
        </b-form-group>
        <div v-if="report_type === 'quarterly'">
            <b-form-group label-cols="4" label-cols-lg="2" :label="$gettext('Quarter')" label-for="quarter-select">
                <b-form-select v-model="quarterModal" :options="QUARTERS" id="quarter-select"></b-form-select>
            </b-form-group>
        </div>
        <div v-if="report_type === 'monthly'">
            <b-form-group label-cols="4" label-cols-lg="2" :label="$gettext('Month')" label-for="month-select">
                <b-form-select v-model="monthModal" :options="MONTHS" id="month-select"></b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    name: "ReportsVATNewModal",
    components: {},
    props: ['financialYears', 'year', 'quarter', 'month', 'consolidated'],
    data() {
        return {
            yearModal: this.year,
            quarterModal: this.quarter,
            monthModal: this.month,
            report_type: this.getReportTypeSelected,
            QUARTERS: [
                { text: 'Q1', value: 'Q1' },
                { text: 'Q2', value: 'Q2' },
                { text: 'Q3', value: 'Q3' },
                { text: 'Q4', value: 'Q4' }
            ],
            MONTHS: [
                { text: this.$gettext('Jan'), value: 1 },
                { text: this.$gettext('Feb'), value: 2 },
                { text: this.$gettext('Mar'), value: 3 },
                { text: this.$gettext('Apr'), value: 4 },
                { text: this.$gettext('May'), value: 5 },
                { text: this.$gettext('Jun'), value: 6 },
                { text: this.$gettext('Jul'), value: 7 },
                { text: this.$gettext('Aug'), value: 8 },
                { text: this.$gettext('Sep'), value: 9 },
                { text: this.$gettext('Oct'), value: 10 },
                { text: this.$gettext('Nov'), value: 11 },
                { text: this.$gettext('Dec'), value: 12 }
            ],
            REPORT_TYPES: [
                { text: this.$gettext('Monthly'), value: 'monthly' },
                { text: this.$gettext('Quarterly'), value: 'quarterly' }
            ]
        }
    },
    methods: {
        resetModal() {
            this.yearModal = this.year;
            this.quarterModal = this.quarter;
            this.monthModal = this.month;
            this.report_type = this.getReportTypeSelected;
        },
        calculateQuarter(month) {
            return 'Q' + Math.floor((month + 2) / 3);
        },
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.handleSubmit();
        },
        handleSubmit() {
            let report_initial_values = {
                company: this.currentCompany.id,
                year: this.yearModal,
                month: this.monthModal,
                quarter: this.monthModal ? this.calculateQuarter(this.monthModal) : this.quarterModal,
                consolidated: this.consolidated,
                status: 'creating'
            };
            this.$store.commit('taxreports/setReportInitialValues', report_initial_values);
            this.$router.push({ name: 'CreateTaxreport'});
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing');
            });
        }
    },
    computed: {
        getReportTypeSelected() {
            if (this.month !== null) {
                return 'monthly'
            }
            else if (this.quarter !== null) {
                return 'quarterly'
            }
            else {
                return null
            }
        },
        ...mapGetters({
          REPORT_MONTHS: "main/getReportMonths",
          REPORT_QUARTERS: "main/getReportQuarters",
          currentCompany: "main/getCurrentCompany",
        })
    }
}
</script>
<style>

</style>